import {TrackByFunction} from '@angular/core';

export const trackById: TrackByFunction<any> = (index: number, item) => item['id'];
export const trackByValue: TrackByFunction<any> = (index: number, item) => item;
export const trackByIndex: TrackByFunction<number> = index => index;
export const trackByProperty =
    <T>(property: keyof T): TrackByFunction<T> =>
    (index: number, item: T) =>
        item[property];
